(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5547],{

/***/ 25547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VehicleDataSpotlight": function() { return /* reexport */ VehicleDataSpotlight; },
  "default": function() { return /* reexport */ VehicleDataSpotlightGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Configurator/VehicleDataSpotlight/vehicle-data-spotlight.module.scss
var vehicle_data_spotlight_module = __webpack_require__(65817);
var vehicle_data_spotlight_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_data_spotlight_module);
// EXTERNAL MODULE: ./lib/animations/TextSwitchTransition/index.ts + 1 modules
var TextSwitchTransition = __webpack_require__(19086);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleDataSpotlight/VehicleDataSpotlight.tsx





var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var VehicleDataSpotlight = function(param) {
    var metric = param.metric, value = param.value, label = param.label, icon = param.icon, _includeLabels = param.includeLabels, includeLabels = _includeLabels === void 0 ? [] : _includeLabels, _isList = param.isList, isList = _isList === void 0 ? false : _isList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (vehicle_data_spotlight_module_default()).spotlight,
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (vehicle_data_spotlight_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    name: icon,
                    size: system/* Size.Large */.$u.Large
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (vehicle_data_spotlight_module_default()).point,
                children: isList ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (vehicle_data_spotlight_module_default()).value,
                    children: [
                        value,
                        " ",
                        metric,
                        " ",
                        includeLabels.includes(label) && label.toLowerCase()
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (vehicle_data_spotlight_module_default()).value,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSwitchTransition/* TextSwitchTransition */.d, {
                                    text: value
                                }),
                                " ".concat(metric)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (vehicle_data_spotlight_module_default()).label,
                            children: label
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleDataSpotlight/VehicleDataSpotlightGroup.tsx








var VehicleDataSpotlightGroup = function(param) {
    var technicalData = param.technicalData, vehicleFuelType = param.vehicleFuelType, vehicleType = param.vehicleType, _includeLabels = param.includeLabels, includeLabels = _includeLabels === void 0 ? [] : _includeLabels, _mobileDataPoints = param.mobileDataPoints, mobileDataPoints = _mobileDataPoints === void 0 ? [] : _mobileDataPoints, _isList = param.isList, isList = _isList === void 0 ? false : _isList;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isLargeTablet = (0,react_responsive.useMediaQuery)({
        maxWidth: vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? 1680 : 1600
    });
    var isSmallTablet = (0,react_responsive.useMediaQuery)({
        maxWidth: vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? 1540 : 1490
    });
    var isLargeMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? 1400 : 1350
    });
    var isMediumMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 1260
    });
    var isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    });
    var electricDataPoints = [
        {
            metric: "miles",
            value: (0,vehicle/* rangeForElectricVehicle */.TR)(technicalData).displayValue ? (0,vehicle/* rangeForElectricVehicle */.TR)(technicalData).displayValue : "---",
            label: "Range"
        },
        {
            metric: "mins",
            value: (0,vehicle/* fastestChargeTimeForElectricVehicle */.ZI)(technicalData).displayValue ? (0,vehicle/* fastestChargeTimeForElectricVehicle */.ZI)(technicalData).displayValue : "---",
            label: "Charging time"
        }, 
    ];
    var iceDataPoints = [
        {
            metric: "secs",
            value: ((ref = technicalData[12]) === null || ref === void 0 ? void 0 : ref.displayValue) ? technicalData[12].displayValue : "---",
            label: "0-62"
        },
        {
            metric: "mpg",
            value: (0,vehicle/* fuelConsumptionValue */.R3)(technicalData).displayValue ? (0,vehicle/* fuelConsumptionValue */.R3)(technicalData).displayValue : "---",
            label: "Fuel consumption"
        }, 
    ];
    var commonCarDataPoints = (0,_to_consumable_array/* default */.Z)(vehicleFuelType === 5 ? electricDataPoints : iceDataPoints).concat([
        {
            metric: "mph",
            value: ((ref1 = technicalData[13]) === null || ref1 === void 0 ? void 0 : ref1.displayValue) ? technicalData[13].displayValue : "---",
            label: "Top speed"
        },
        {
            metric: "bhp",
            value: ((ref2 = technicalData[21]) === null || ref2 === void 0 ? void 0 : ref2.displayValue) ? technicalData[21].displayValue : "---",
            label: "Power"
        },
        {
            metric: "",
            value: ((ref3 = technicalData[133]) === null || ref3 === void 0 ? void 0 : ref3.displayValue) ? technicalData[133].displayValue : "---",
            label: "Insurance group"
        },
        {
            metric: "litres",
            value: ((ref4 = technicalData[40]) === null || ref4 === void 0 ? void 0 : ref4.displayValue) ? technicalData[40].displayValue : "---",
            label: "Boot space"
        }, 
    ]);
    var commonVanDataPoints = [
        vehicleFuelType === 5 ? {
            metric: "miles",
            value: (0,vehicle/* rangeForElectricVehicle */.TR)(technicalData).displayValue ? (0,vehicle/* rangeForElectricVehicle */.TR)(technicalData).displayValue : "---",
            label: "Range"
        } : {
            metric: "mpg",
            value: (0,vehicle/* fuelConsumptionValue */.R3)(technicalData).displayValue ? (0,vehicle/* fuelConsumptionValue */.R3)(technicalData).displayValue : "---",
            label: "Fuel consumption"
        },
        {
            metric: "tonnes",
            value: ((ref5 = technicalData[14]) === null || ref5 === void 0 ? void 0 : ref5.displayValue) ? (Number(technicalData[14].displayValue) / 1000).toFixed(2) : "---",
            label: "Weight"
        },
        {
            metric: "tonnes",
            value: ((ref6 = technicalData[32]) === null || ref6 === void 0 ? void 0 : ref6.displayValue) ? (Number(technicalData[32].displayValue) / 1000).toFixed(2) : "---",
            label: "Payload"
        },
        {
            metric: "metres",
            value: ((ref7 = technicalData[36]) === null || ref7 === void 0 ? void 0 : ref7.displayValue) ? (Number(technicalData[36].displayValue) / 1000).toFixed(2) : "---",
            label: "Load length"
        },
        {
            metric: "metres",
            value: ((ref8 = technicalData[38]) === null || ref8 === void 0 ? void 0 : ref8.displayValue) ? (Number(technicalData[38].displayValue) / 1000).toFixed(2) : "---",
            label: "Load height"
        },
        {
            metric: "metres",
            value: ((ref9 = technicalData[37]) === null || ref9 === void 0 ? void 0 : ref9.displayValue) ? (Number(technicalData[37].displayValue) / 1000).toFixed(2) : "---",
            label: "Load width"
        }, 
    ];
    var baseDataPoints = vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? commonVanDataPoints : commonCarDataPoints;
    var dataPoints = isMobile && mobileDataPoints.length ? mobileDataPoints.map(function(label) {
        return baseDataPoints.find(function(point) {
            return point.label === label;
        });
    }).filter(Boolean) : baseDataPoints;
    var responsiveDataPoints = function() {
        var numberOfVisiblePoints = dataPoints.length;
        if (isMobile) {
            return dataPoints;
        }
        if (isLargeTablet) {
            numberOfVisiblePoints -= 1;
        }
        if (isSmallTablet) {
            numberOfVisiblePoints -= 1;
        }
        if (isLargeMobile) {
            numberOfVisiblePoints -= 1;
        }
        if (isMediumMobile) {
            numberOfVisiblePoints -= 1;
        }
        return dataPoints.slice(0, numberOfVisiblePoints);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: isList ? (vehicle_data_spotlight_module_default()).list : (vehicle_data_spotlight_module_default()).container,
        children: responsiveDataPoints().map(function(point, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (vehicle_data_spotlight_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDataSpotlight, {
                        metric: point.metric,
                        value: point.value,
                        label: point.label,
                        includeLabels: includeLabels,
                        isList: isList
                    })
                ]
            }, point.label);
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleDataSpotlight/index.tsx




/***/ }),

/***/ 19086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ TextSwitchTransition; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./lib/animations/TextSwitchTransition/text-switch-transition.module.scss
var text_switch_transition_module = __webpack_require__(89398);
var text_switch_transition_module_default = /*#__PURE__*/__webpack_require__.n(text_switch_transition_module);
;// CONCATENATED MODULE: ./lib/animations/TextSwitchTransition/TextSwitchTransition.tsx




var TextSwitchTransition = function(param) {
    var text = param.text;
    var nodeRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTransition/* default */.Z, {
        mode: "out-in",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
            nodeRef: nodeRef,
            addEndListener: function(done) {
                var ref;
                (ref = nodeRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("transitionend", done, false);
            },
            classNames: {
                enter: "".concat((text_switch_transition_module_default()).enter, " ").concat((text_switch_transition_module_default()).slide),
                enterActive: (text_switch_transition_module_default())["enter--active"],
                enterDone: "".concat((text_switch_transition_module_default())["enter--done"], " ").concat((text_switch_transition_module_default()).slide),
                exit: "".concat((text_switch_transition_module_default()).exit, " ").concat((text_switch_transition_module_default()).slide),
                exitActive: (text_switch_transition_module_default())["exit--active"],
                exitDone: "".concat((text_switch_transition_module_default())["exit--done"], " ").concat((text_switch_transition_module_default()).slide)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: nodeRef,
                children: text
            })
        }, text)
    });
};

;// CONCATENATED MODULE: ./lib/animations/TextSwitchTransition/index.ts



/***/ }),

/***/ 65817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"value":"vehicle-data-spotlight_value__gBdJd","label":"vehicle-data-spotlight_label__f8j76","point":"vehicle-data-spotlight_point__MJOjp","container":"vehicle-data-spotlight_container__ZfNwC","divider":"vehicle-data-spotlight_divider__w2mxr","spotlight":"vehicle-data-spotlight_spotlight__SxPIq","character":"vehicle-data-spotlight_character__keR1l","list":"vehicle-data-spotlight_list__Ibyaq","phAnimation":"vehicle-data-spotlight_phAnimation__rD3Bv"};

/***/ }),

/***/ 89398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slide":"text-switch-transition_slide__ONYgZ","enter":"text-switch-transition_enter__5PajH","enter--active":"text-switch-transition_enter--active__9R8fU","enter--done":"text-switch-transition_enter--done__W2Gnr","exit":"text-switch-transition_exit__JqB_c","exit--active":"text-switch-transition_exit--active__PoSzO","phAnimation":"text-switch-transition_phAnimation__H1qE1"};

/***/ })

}]);